module.exports = __webpack_public_path__ + "img/m2.4a23ea4a.png";